import { render, staticRenderFns } from "./addHomeSupport.vue?vue&type=template&id=c1f01ef8&scoped=true"
import script from "./addHomeSupport.vue?vue&type=script&lang=js"
export * from "./addHomeSupport.vue?vue&type=script&lang=js"
import style0 from "./addHomeSupport.vue?vue&type=style&index=0&id=c1f01ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f01ef8",
  null
  
)

export default component.exports